import { css } from '@/styled-system/css';

export const panelOutlet = css({
  position: 'absolute',
  inset: 0,
  zIndex: 'zIndexOverParent',
  backgroundColor: 'hpxWhite',
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  willChange: 'transform',
  transitionProperty: 'transform',
  transitionDuration: '300ms',
  transitionTimingFunction: 'ease-out',
});

export const panelOutletHidden = css({
  transform: 'translateX(100%)',
  pointerEvents: 'none',
});

export const panelOutletVisible = css({
  transform: 'translateX(0)',
});

export const panelHeader = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  minHeight: '48px',
  flexShrink: 0,
  px: '4x',
  py: '2x',
  position: 'sticky',
  top: 0,
  bg: 'hpxWhite',
  zIndex: 'zIndexParent',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: 'hpxGrey400',
});

export const panelHeaderColumns = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  gap: '2x',
});

export const panelHeaderLeft = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
  minWidth: 0,
});

export const panelHeaderRight = css({
  display: 'flex',
  gap: '2x',
  alignItems: 'center',
  flexShrink: 0,
});

export const panelHeaderTitle = css({
  fontSize: 'md',
  fontWeight: 'bold',
  lineHeight: 1,
  color: 'hpxBlue600',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  margin: 0,
});

export const panelHeaderSubtitle = css({
  fontSize: 'tiny',
  color: 'hpxGrey600',
  margin: 0,
  lineHeight: 1.2,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  animationName: 'slideUpFadeIn',
  animationDuration: '150ms',
  animationTimingFunction: 'ease-out',
  animationFillMode: 'both',
});

export const panelBackButton = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'xs',
  bg: 'transparent',
  border: 'none',
  cursor: 'pointer',
  color: 'hpxBlue600',
  fontSize: 'sm',
  fontWeight: 'bold',
  fontFamily: 'inherit',
  padding: '1x',
  borderRadius: '4px',
  _hover: {
    bg: 'hpxGrey100',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});

export const panelBody = css({
  flex: 1,
  px: '4x',
  py: '2x',
});
